module.exports = __webpack_public_path__ + "static/sidebar2-ba4e924e24308f5cecab798b486b9b0c.png";